import type { NavigationItem } from '@/types/layout.types';
import { ROUTES } from './routes.constants';
import HomeIcon from '@/assets/icons/main-bottom-navigation/home.svg?react';
import EventsIcon from '@/assets/icons/main-bottom-navigation/events.svg?react';
import LeaderboardIcon from '@/assets/icons/main-bottom-navigation/leaderboard.svg?react';
import LearnIcon from '@/assets/icons/main-bottom-navigation/learn.svg?react';
import ProfileIcon from '@/assets/icons/main-bottom-navigation/profile.svg?react';

export const MOBILE_BOTTOM_NAV_ICONS: Record<string, NavigationItem['icon']> = {
	Home: HomeIcon,
	Events: EventsIcon,
	Leaderboard: LeaderboardIcon,
	Learn: LearnIcon,
	Profile: ProfileIcon,
};

/**
 * Routes rendered in the light shell (new sidebar, white mobile header, light bottom nav) besides
 * Home and the courses pages. Matched by exact path: page names come from the last URL segment, so
 * `/head-to-head/:eventId/:lobbyId/leaderboard` would otherwise pass for the global leaderboard.
 */
export const LIGHT_SHELL_ROUTES = [ROUTES.EVENTS, ROUTES.LEADERBOARD, ROUTES.PROFILE];

/**
 * Mobile bottom padding for light shell pages: with LayoutMain's own `pb-10` it keeps the last item
 * 16px above the floating bottom nav (68px bar over a `max(32px, safe-area)` inset).
 */
export const LIGHT_SHELL_NAV_CLEARANCE_CLASS =
	'max-lg:pb-[calc(max(32px,env(safe-area-inset-bottom))+44px)]';

/** Mobile offset that parks a fixed element 8px above the floating light bottom nav. */
export const LIGHT_SHELL_ABOVE_NAV_CLASS =
	'bottom-[calc(max(32px,env(safe-area-inset-bottom))+76px)]';

export const NO_LAYOUT_PAGES = [
	'Auth',
	'ProfileSetup',
	'ParentEmailVerification',
	'ParentalConsent',
	'ExternalLeaderboard',
];

export const PAGES_WITHOUT_NAV = [
	'EditProfile',
	'MarketPerformance',
	'Auth',
	'refer',
	'ProfileSetup',
	'ParentEmailVerification',
	'ParentalConsent',
	'ExternalLeaderboard',
];

/** Legacy short URLs shared externally before /sponsor/:slug existed. */
export const LEGACY_SPONSOR_SLUGS = [
	'2025challenge',
	'ambipredicts',
	'asiapickleballinsider',
	'boxboxbox',
	'butterspklspringseason2026paldohan',
	'butterspredictkic2025',
	'champzero',
	'chippuday',
	'couchcrew',
	'davidlombardi',
	'eagle',
	'explicitesports',
	'houseofstrauss',
	'iheartmedia',
	'kenofficialm7predictions',
	'mingmongtvkis4predictions',
	'monzabarcade',
	'mplseason17xkenofficial',
	'professorjoseph',
	'publiclobby',
	'senbenedetta',
	'seyrahkicprediction',
	'seyrahm7lobby',
	'shikigami',
	'sportstalk790',
	'tosspizzeria',
	'twishpkl2026',
	'yo1phhokpredictions',
	'yugingaming',
];
